module.exports = __webpack_public_path__ + "static/media/logo-red.37a1f32b.svg";